/*
 * @创建文件时间: 2019-11-22 14:57:00
 * @最后修改人: lfq
 * @最后修改时间: 2020-05-01 11:59:53
 * @联系Qq:1360484677
 * @文件介绍: 辅助资产
 */
export default [{
    path: 'bdStorehouseTable',
    name: 'bdStorehouseTable',
    meta: {
        title: '仓库',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdStorehouseTable')
}, {
    path: 'bdInterchangeTable',
    name: 'bdInterchangeTable',
    meta: {
        title: '立体交叉',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdInterchangeTable')
}, {
    path: 'bdMaterialFieldTable',
    name: 'bdMaterialFieldTable',
    meta: {
        title: '料场',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdMaterialFieldTable')
}, {
    path: 'bdMixingStationTable',
    name: 'bdMixingStationTable',
    meta: {
        title: '拌合站',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdMixingStationTable')
}, {
    path: 'bdTollStationTable',
    name: 'bdTollStationTable',
    meta: {
        title: '收费站',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdTollStationTable')
}, {
    path: 'bdTrafficFlowStation',
    name: 'bdTrafficFlowStation',
    meta: {
        title: '交通调查站',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdTrafficFlowStation')
}, {
    path: 'bdAtubeStation',
    name: 'bdAtubeStation',
    meta: {
        title: '养管站',
        auth: true
    },
    component: () =>
        import ('@/views/basic/auxiliary/bdAtubeStation')
}] //yangguanzhan